<div [title]="score" class="flex items-center">
  @for (i of scoreRange; track i) {
    @if (isFullStar(i)) {
      <mat-icon class="fill text-gray">star</mat-icon>
    }
    @if (!isFullStar(i) && !isHalfStar(i)) {
      <mat-icon class="text-gray">star</mat-icon>
    }
    @if (!isFullStar(i) && isHalfStar(i)) {
      <mat-icon class="text-gray">star_half</mat-icon>
    }
  }
</div>
